



























































import {
    defineComponent,
    PropType,
    watch,
    computed
} from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { useBattery } from "@/utilities/useBattery";
export default defineComponent({
    components: {
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue")
    },
    props: {
        imgSrc: { type: String, required: true },
        paired: { type: Boolean, default: false },
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(props, { emit }) {
        const status = computed(() => {
            if (props.value) {
                return props.value.attachedDeviceId
                    ? props.value.attachedDeviceId !== ""
                    : false;
            } else {
                return false;
            }
        });
        const responsive = computed<boolean>(() => {
            if (props.value.attachedDeviceId != null) {
                if (props.value.age <= 1) {
                    return true;
                } else {
                    return false;
                }
            }
        });

        const rawBattery = computed(() => props.value?.battery ?? null);

        const { level: batteryLevel, icon: batteryIcon, label: batteryLabel } = useBattery(rawBattery);

        watch(
            () => props.value,
            newValue => {
                if (newValue) {
                    console.log(newValue.battery);
                }
            }
        );

        const onEnroll = () => {
            if (props.value) emit('enroll', props.value);
        };

        const onUnpair = () => {
            if (props.value) emit('unpair', props.value);
        };

        return {
            onEnroll,
            onUnpair,
            status,
            responsive,
            batteryLevel,
            batteryIcon,
            batteryLabel,
        };
    }
});
